{
  "nav": {
    "explore": "Explore",
    "paths": "Paths",
    "quiz": "Quiz",
    "topics": "Topics",
    "families": "For Families",
    "schools": "For Schools"
  },
  "actions": {
    "notifications": "Notifications",
    "accountMenu": "Account menu",
    "signOut": "Sign Out",
    "startFree": "Start Free",
    "openMenu": "Open menu",
    "closeMenu": "Close menu"
  },
  "menu": {
    "profile": "My Profile",
    "badges": "My Badges",
    "dashboard": "Dashboard",
    "progress": "My Progress"
  },
  "labels": {
    "childAvatar": "Child avatar",
    "userAvatar": "User avatar",
    "account": "Account"
  },
  "aria": {
    "mainNav": "Main navigation",
    "mobileNav": "Mobile navigation"
  }
}
